// Module
var code = "<react-component name=\"PaymentFailuresReport\"></react-component>\n";
// Exports
module.exports = code;